import script from "./PlanTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanTab.vue?vue&type=script&setup=true&lang=js"

import "./PlanTab.vue?vue&type=style&index=0&id=6cc063f0&lang=scss"

const __exports__ = script;

export default __exports__